function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBuild2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "194px",
    height: "251px",
    viewBox: "0 0 194 250",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear0",
    gradientUnits: "userSpaceOnUse",
    x1: 0.5,
    y1: 0,
    x2: 0.5,
    y2: 1,
    gradientTransform: "matrix(-94.273438,0.000000000000011518,-0.000000000000027063,-220.457031,194.003906,220.457031)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(41.176471%,42.352941%,44.313725%)",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.143,
    style: {
      stopColor: "rgb(27.843137%,33.72549%,41.568627%)",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(27.843137%,33.72549%,41.568627%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear1",
    gradientUnits: "userSpaceOnUse",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    y2: 0,
    gradientTransform: "matrix(94.273438,0,0,220.453125,0,29.515625)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(41.176471%,42.352941%,44.313725%)",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.131,
    style: {
      stopColor: "rgb(27.843137%,33.72549%,41.568627%)",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(27.843137%,33.72549%,41.568627%)",
      stopOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear0)"
    },
    d: "M 99.730469 220.457031 L 194.003906 220.457031 L 194.003906 0 L 99.730469 53.878906 Z M 99.730469 220.457031 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear1)"
    },
    d: "M 0 29.515625 L 0 249.96875 L 94.273438 249.96875 L 94.273438 83.394531 Z M 0 29.515625 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuild2);
export default __webpack_public_path__ + "static/media/build2.7e53583c8468d1dbfa15a70b4f399d0e.svg";
export { ForwardRef as ReactComponent };